/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  LayerResultFilterResponse,
  LayerResultsFilter,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LayerResultFilterResponseFromJSON,
    LayerResultFilterResponseToJSON,
    LayerResultsFilterFromJSON,
    LayerResultsFilterToJSON,
} from '../models/index';

export interface GetLayerResultsRequest {
    submissionId: string;
    layerResultsFilter: LayerResultsFilter;
}

/**
 * 
 */
export class LayerResultsApi extends runtime.BaseAPI {

    /**
     * Get layer results
     */
    async getLayerResultsRaw(requestParameters: GetLayerResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LayerResultFilterResponse>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getLayerResults().'
            );
        }

        if (requestParameters['layerResultsFilter'] == null) {
            throw new runtime.RequiredError(
                'layerResultsFilter',
                'Required parameter "layerResultsFilter" was null or undefined when calling getLayerResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/layer-results/filter`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LayerResultsFilterToJSON(requestParameters['layerResultsFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LayerResultFilterResponseFromJSON(jsonValue));
    }

    /**
     * Get layer results
     */
    async getLayerResults(requestParameters: GetLayerResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LayerResultFilterResponse> {
        const response = await this.getLayerResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
